import React from "react";
import {
  Typography,
  Button,
  Grid,
  Card,
  Box,
} from "@mui/material";
import AppHeader from "./AppHeader";

import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";

import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer,
  BarChart, Bar
} from "recharts";

const Dashboard = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsLoggedIn(false);
    navigate("/login");
  };

  // 🔹 Mock Data (replace with API later)
  const attendanceTrend = [
    { date: "Mon", present: 120 },
    { date: "Tue", present: 118 },
    { date: "Wed", present: 125 },
    { date: "Thu", present: 122 },
    { date: "Fri", present: 119 },
    { date: "Sat", present: 60 },
    { date: "Sun", present: 0 },
    { date: "Mon", present: 125 },
    { date: "Tue", present: 110 },
    { date: "Wed", present: 135 },
    { date: "Thu", present: 112 },
    { date: "Fri", present: 129 },
    { date: "Sat", present: 70 },
    { date: "Sun", present: 0 },
  ];

  const lateByDept = [
    { dept: "IT", late: 8 },
    { dept: "Sales", late: 6 },
    { dept: "HR", late: 3 },
    { dept: "Finance", late: 2 },
  ];

  return (
    <Box sx={{ height: "100vh", bgcolor: "#e8f5e9", overflow: "auto" }}>
      <AppHeader onLogout={handleLogout} />

      <Box sx={{ p: 4, maxWidth: "1600px", mx: "auto" }}>
        {/* TITLE */}
        <Typography variant="h4" sx={{ mb: 1, color: "#2e7d32", fontWeight: "bold" }}>
          Dashboard Overview
        </Typography>

        {/* KPI CARDS */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          {[
            { label: "Today Present", value: 123, icon: <CheckCircleIcon />, color: "#2e7d32" },
            { label: "Absent", value: 32, icon: <WarningIcon />, color: "#d32f2f" },
            { label: "Late Check-Ins", value: 8, icon: <AccessTimeIcon />, color: "#ffa000" },
            { label: "Remote / Field", value: 14, icon: <LocationOnIcon />, color: "#0288d1" },
          ].map((item, i) => (
            <Grid item xs={12} md={6} lg={3} key={i}>
              <Card sx={{ p: 2, width:"100px", borderLeft: `6px solid ${item.color}` }}>
                <Typography variant="subtitle2">{item.label}</Typography>
                <Typography variant="h4" sx={{ fontWeight: "bold", mt: 1 }}>
                  {item.value}
                </Typography>
                {React.cloneElement(item.icon, {
                  sx: { fontSize: 24, color: item.color, mt: 1}
                })}
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* CHARTS SECTION */}
        <Grid container spacing={3} sx={{ mb: 3}}>
          {/* Attendance Trend */}
          <Grid item xs={12} md={8} minWidth={650}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Attendance Trend (This Week)
              </Typography>
              <ResponsiveContainer width="100%" height={260}>
                <LineChart data={attendanceTrend}>
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="present"
                    stroke="#2e7d32"
                    strokeWidth={3}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Card>
          </Grid>

          {/* Late by Department */}
          <Grid item xs={12} md={4} minWidth={350}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Late Check-ins by Department
              </Typography>
              <ResponsiveContainer width="100%" height={260}>
                <BarChart data={lateByDept}>
                  <XAxis dataKey="dept" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="late" fill="#ffa000" />
                </BarChart>
              </ResponsiveContainer>
            </Card>
          </Grid>
        </Grid>

        {/* QUICK ACTIONS */}
        <Typography variant="h5" sx={{ mb: 2, color: "#2e7d32", fontWeight: 600 }}>
          Quick Actions
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6">Staff Management</Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Manage all staff records
              </Typography>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#2e7d32" }}
                onClick={() => navigate("/staff")}
              >
                Open Staff List
              </Button>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6">Add New Staff</Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Register new staff
              </Typography>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#2e7d32" }}
                onClick={() => navigate("/staff/new")}
              >
                Add Staff
              </Button>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3 }}>
              <Typography variant="h6">Export Data</Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Download reports
              </Typography>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#2e7d32" }}
                onClick={() => navigate("/export/t2hr")}
              >
                Export
              </Button>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;